// extracted by mini-css-extract-plugin
module.exports = {"root":"SubPageHeader_root__jtvF7","product":"SubPageHeader_product__3oRau"};